import { Check, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/lib/motion";

const FEATURES = [
  "Gestion de la paie adaptée à la réglementation ivoirienne",
  "Outils RH pour le suivi de vos équipes",
  "Optimisation salariale (réduction de l'impôt sur le salaire)",
];

export default function Boussole() {
  return (
    <section
      id="boussole"
      className="relative overflow-hidden bg-gradient-to-br from-korban-navy via-korban-navy2 to-korban-navy py-24 md:py-32"
      data-testid="section-boussole"
    >
      <div
        className="pointer-events-none absolute -right-40 -top-40 h-[480px] w-[480px] rounded-full"
        style={{ background: "radial-gradient(circle, rgba(249,178,51,0.15) 0%, rgba(10,31,51,0) 70%)" }}
      />
      <div className="relative mx-auto grid max-w-6xl gap-12 px-5 lg:grid-cols-[1.2fr_0.8fr] lg:items-center">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-korban-gold">Notre solution logicielle</p>
          <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
            Boussole de la Paie CI{" "}
            <span className="align-middle text-[0.5em] font-normal text-slate-400">(SIRH-CI/PAIE)</span>
          </h2>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-slate-300">
            Notre solution logicielle de gestion des ressources humaines et de la paie, conforme à la réglementation
            ivoirienne et destinée aux entreprises exerçant en Côte d'Ivoire.
          </p>
          <ul className="mt-8 space-y-4">
            {FEATURES.map((f) => (
              <li key={f} className="flex items-start gap-3 text-[0.98rem] text-slate-100">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-korban-gold/20">
                  <Check size={12} className="text-korban-gold" />
                </span>
                {f}
              </li>
            ))}
          </ul>
          <a
            href="https://boussoledelapaieci.com"
            target="_blank"
            rel="noopener"
            data-testid="cta-boussole-paie"
            className="mt-9 inline-flex items-center gap-2 rounded-md bg-korban-gold px-7 py-3.5 font-bold text-korban-navy shadow-[0_10px_30px_rgba(249,178,51,0.3)] transition-all hover:-translate-y-0.5 hover:bg-korban-golddark"
          >
            Accès à la plateforme <ArrowUpRight size={17} />
          </a>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="rounded-2xl border border-white/15 bg-white/[0.06] p-9 text-center backdrop-blur-sm">
            <img
              src="/embleme_korban.png"
              alt="Emblème KORBAN CONSULTING"
              className="mx-auto h-20 w-20 object-contain"
            />
            <p className="mt-6 font-display text-2xl font-bold text-korban-gold">GRH & PAIE</p>
            <p className="mt-4 leading-relaxed text-slate-300">
              Créez votre compte sur la page de connexion pour bénéficier de l'accès.
            </p>
            <p className="mt-5 font-display text-xl font-semibold text-white">boussoledelapaieci.com</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
